// 全量备份：直接导出 / 导入整个持久化状态（localStorage），无损，含番茄 / 照片 / 经期 / 分类设置等一切。
// 定位区别：CSV 是「人可读 / 可进 Excel 分析」的子集；这个 JSON 是「换设备搬全部数据」用的。
const KEY = 'timeblock-app-v1';

export function exportBackup() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) { alert('当前没有可备份的数据'); return; }
    const blob = new Blob([raw], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `时间块_全量备份_${new Date().toISOString().slice(0, 10)}.json`;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
  } catch (e) {
    console.error(e);
    alert('备份失败：' + e.message);
  }
}

export async function importBackup() {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.json,application/json';
  input.onchange = async () => {
    const file = input.files[0];
    if (!file) return;
    try {
      const text = await file.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch (e) { alert('这不是有效的 JSON 文件'); return; }
      if (!parsed || typeof parsed !== 'object' || !parsed.data) {
        alert('这个 JSON 看起来不是时间块的全量备份（缺 data 字段）');
        return;
      }
      const dayCount = Object.keys(parsed.data || {}).length;
      if (!confirm(`导入会用备份【覆盖当前全部数据】（时间块 / 番茄 / 经期 / 分类设置等）。\n备份含 ${dayCount} 天数据。\n当前数据会先存到浏览器逃生键 timeblock-backup-before-import。\n\n确认覆盖并刷新？`)) return;
      const cur = localStorage.getItem(KEY);
      if (cur) localStorage.setItem('timeblock-backup-before-import', cur);
      localStorage.setItem(KEY, text);
      alert('导入成功，点「确定」后页面会刷新，载入恢复的数据。');
      location.reload();
    } catch (e) {
      console.error(e);
      alert('导入失败：' + e.message);
    }
  };
  input.click();
}
